import { toolInput } from "../tool-input";

export function stringField(input: unknown, key: string): string | null {
  return toolInput.isRecord(input) ? toolInput.trimmed(input[key]) : null;
}
